import { useCallback, useMemo } from "react";

import createStore from "@Stores/base-factories"
import { hookCustomFieldsList, hookSiteList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionsFactory('data-extractors')
  .extendHookCollectionFactory('data-extractor')
  .extend(hookCustomFieldsList())
  .extend(hookSiteList())
  .extend(({ fetch, siteSelected: { id: siteId }, collection: { collectionURL }, collections: { collectionsURL } }) => {
    const downloadFile = useCallback(async id => await fetch({
      method: 'GET',
      url: `${collectionsURL}/download`,
      responseType: 'blob',
      params: { siteId, id },
    }), [fetch, siteId, collectionsURL])

    const deleteFile = useCallback(async id => await fetch({
      method: 'DELETE',
      url: `${collectionURL}`,
      params: { siteId, id },
    }), [fetch, siteId, collectionURL])

    const cancelProcess = useCallback(async id => await fetch({
      url: `${collectionURL}/cancel`,
      params: { siteId, id },
    }), [fetch, siteId, collectionURL])

    const retryProcess = useCallback(async id => await fetch({
      url: `${collectionURL}/retry`,
      params: { siteId, id },
    }), [fetch, siteId, collectionURL])

    return useMemo(() => ({
      downloadFile, deleteFile, cancelProcess, retryProcess,
    }), [downloadFile, deleteFile, cancelProcess, retryProcess])
  })
  .factory()

export {
  Provider as DataExtractorProvider,
  useStore as useDataExtractorStore,
}
